import React from 'react';
import { Button, Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import type { IMoreActionsDropdownProps } from './types';

export const MoreActionsDropdown: React.FC<IMoreActionsDropdownProps> = (props) => {
  const { items, onClick } = props;

  return (
    <Dropdown menu={{ items, onClick }} placement='bottomLeft' trigger={['click']}>
      <Button icon={<MoreOutlined style={{ fontSize: 20 }} />} type='text' />
    </Dropdown>
  );
};
